import React from "react";

const ExternalWebsiteEmbed = ({ url, title }) => {
  return (
    <div style={{ width: "100%", height: "auto" }}>
      <iframe
        src={url}
        title={title}
        width="100%"
        height="100%"
        frameBorder="0" // Optional: removes the default iframe border
        // Optional security enhancement: restrict capabilities of the embedded content
        // sandbox="allow-scripts allow-forms allow-same-origin"
      />
    </div>
  );
};

export default ExternalWebsiteEmbed;
